import { z } from 'zod';

export const OutdoorBarArticleSetModelSchema = z.object({
    name: z.string(),
    elements: z.array(
        z.object({
            name: z.string(),
            meassure: z.string(),
            value: z.number(),
        }),
    ).optional().nullable(),
});

export type OutdoorBarArticleSetModel = z.infer<typeof OutdoorBarArticleSetModelSchema>;
